<template>
  <div class="main">
    <img src="@/assets/images/paysuccess.png" class="image">
    <div class="info-group">支付成功</div>
    <div class="btn" @click="JumpToHome">返回</div>
  </div>
</template>
<script>
    export default {
        name: "payticket",
      data(){
          return {
            out_trade_no:''
          }
      },
      mounted() {
        this.wxInit();
      },
      methods:{
        JumpToHome() {
          let url = "http://"+process.env.CLIENT_HOST_ENV+'/#/?auto=1'
          var mchData = {
            action: 'jumpOut',
            jumpOutUrl: url, //跳转的页面
          };
          const postData = JSON.stringify(mchData);
          window.parent.postMessage(postData, 'https://payapp.weixin.qq.com');n
        },
        wxInit() {
          //初始化小票
          let mchData = {
            action: 'onIframeReady',
            displayStyle: 'SHOW_CUSTOM_PAGE',
          };
          let postData = JSON.stringify(mchData);
          window.parent.postMessage(postData, 'https://payapp.weixin.qq.com');
        },
      },
      created() {
        let head = document.querySelector('head');
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js';
        head.appendChild(script);

        let that = this;
        let query = this.$route.query;
        that.out_trade_no = query.out_trade_no;
      }
    }
</script>
<style scoped>
  .main{
    width: 100%;
  }
  .image{
    width: 80px;
    height: 80px;
    display: block;
    margin: 40px auto;
  }
  .info-group{
    width: 100%;
    text-align: center;
    color: #00a720;
    font-size: 22px;
  }
  .btn{
    width: 80%;
    margin: 60px auto;
    height: 40px;
    font-size: 13px;
    text-align: center;
    line-height: 40px;
    border-radius: 10px;
    color: #fff;
    background: #1fe66a;
  }
</style>



// WEBPACK FOOTER //
// src/pages/payticket.vue